export const loadPendoScript = () =>
    new Promise<void>(resolve => {
        (window as any).pendo = (window as any).pendo ?? {};
        const pendo = (window as any).pendo;
        pendo._q = pendo._q ?? [];

        const methods = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
        methods.forEach(method => {
            pendo[method] =
                pendo[method] ??
                function () {
                    // eslint-disable-next-line prefer-rest-params
                    const args = Array.prototype.slice.call(arguments, 0);
                    pendo._q[method === 'initialize' ? 'unshift' : 'push']([method].concat(args));
                };
        });

        // Load the external Pendo script
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://cdn.pendo.io/agent/static/0359ffe9-310c-40b2-6e51-9ad6adde51e0/pendo.js`;
        script.onload = () => {
            resolve();
        };

        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode?.insertBefore(script, firstScript);
    });
